document.addEventListener("DOMContentLoaded", () => {
	preloadIntroImage();
});

function preloadIntroImage() {
	let image = document.querySelectorAll('.intro-section .content-holder img');
	if(!image.length) return;

	image.forEach(el => {
		let parent = document.querySelector('head');
		let headTitle = parent.querySelector('title');
		let src = el.getAttribute('src');
		let prefetch = document.createElement('link');
		let preconnect = document.createElement('link');
		prefetch.setAttribute('rel', 'dns-prefetch');
		prefetch.setAttribute('href', src);
		preconnect.setAttribute('rel', 'preconnect');
		preconnect.setAttribute('href', src);
		parent.insertBefore(prefetch, headTitle);
		parent.insertBefore(preconnect, headTitle);
	});
}